import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { Router, NavigationEnd, RouterModule } from '@angular/router';

import { EventService } from '../../../core/services/event.service';
import { FooterComponent } from '../footer/footer.component';
import { TopbarComponent } from '../topbar/topbar.component';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { BsModalService, ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { NotificationService } from 'src/app/core/services/notification.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { RootReducerState } from 'src/app/modals';
import { markNotification } from 'src/app/modals/Dashboard/dashboard.action';

// import { SIDEBAR_TYPE } from "../layouts.model";

@Component({
  selector: 'app-vertical',
  templateUrl: './vertical.component.html',
  styleUrls: ['./vertical.component.scss'],
  standalone:true,
  imports:[RouterModule,FooterComponent,TopbarComponent,SidebarComponent, ModalModule, TranslateModule]
})

/**
 * Vertical component
 */
export class VerticalComponent implements OnInit, AfterViewInit {

  @ViewChild('notificationModal') notificationModal!: ModalDirective;
  notification: any;
  isCondensed: any = false;
  sidebartype: string;

  constructor(
        private router: Router, 
        private eventService: EventService, 
        public notificationService: NotificationService,
        public translate: TranslateService,
        private store: Store<RootReducerState>,
      ) {
    this.router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        document.body.classList.remove('sidebar-enable');
      }
    });
  }

  ngOnInit() {

    document.body.setAttribute('data-layout', 'vertical');

    this.notificationService.notification$.subscribe((notif) => {
      if (notif && this.notificationModal) {
        this.notification = notif;
        this.openNotification();
      } else if (!notif && this.notificationModal) {
        this.closeNotification(false); // optional param to avoid another emit
      }
    });
  }

  isMobile() {
    const ua = navigator.userAgent;
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua);
  }

  ngAfterViewInit() {
  }

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked() {
    document.body.classList.toggle('right-bar-enabled');
  }

  /**
   * On mobile toggle button clicked
   */
  onToggleMobileMenu() {
    this.isCondensed = !this.isCondensed;
    document.body.classList.toggle('sidebar-enable');
    document.body.classList.toggle('vertical-collpsed');

    if (window.screen.width <= 768) {
      document.body.classList.remove('vertical-collpsed');
    }
  }

  openNotification() {
    this.notificationModal?.show();
  }

  closeNotification(emit: boolean = true) {
    if (emit) {
      this.notificationModal?.hide();
      this.notificationService.clear();
      this.store.dispatch(markNotification());
    }
  }
}
